import fragmentShader from "./shader.frag";
import vertexShader from "./shader.vert";

const canvas = document.getElementById("canvas");
const gl = canvas.getContext("webgl");

function createShader(gl, type, source) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, source);
  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    console.error("Shader compile error:", gl.getShaderInfoLog(shader));
    gl.deleteShader(shader);
    return null;
  }
  return shader;
}

function createProgram(gl, vertexShader, fragmentShader) {
  const program = gl.createProgram();
  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);
  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    console.error("Program link error:", gl.getProgramInfoLog(program));
    gl.deleteProgram(program);
    return null;
  }
  return program;
}

const vShader = createShader(gl, gl.VERTEX_SHADER, vertexShader);
const fShader = createShader(gl, gl.FRAGMENT_SHADER, fragmentShader);
const program = createProgram(gl, vShader, fShader);

const positionBuffer = gl.createBuffer();
gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
gl.bufferData(
  gl.ARRAY_BUFFER,
  new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]),
  gl.STATIC_DRAW,
);

const aPosition = gl.getAttribLocation(program, "aPosition");
gl.enableVertexAttribArray(aPosition);
gl.vertexAttribPointer(aPosition, 2, gl.FLOAT, false, 0, 0);

const uniforms = {
  uColor1: gl.getUniformLocation(program, "uColor1"),
  uColor2: gl.getUniformLocation(program, "uColor2"),
  uColor3: gl.getUniformLocation(program, "uColor3"),
  uProportion1: gl.getUniformLocation(program, "uProportion1"),
  uProportion2: gl.getUniformLocation(program, "uProportion2"),
  uTime: gl.getUniformLocation(program, "uTime"),
  uMovementAmplitude: gl.getUniformLocation(program, "uMovementAmplitude"),
  uResolution: gl.getUniformLocation(program, "uResolution"),
  uNoiseScale: gl.getUniformLocation(program, "uNoiseScale"),
  uMovementSpeed: gl.getUniformLocation(program, "uMovementSpeed"),
};

function hexToRGB(hex) {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  return [r, g, b];
}

function initUniforms() {
  const proportion1 = 33;
  const proportion2 = 52;
  const proportion3 = 0;
  const totalProportion = proportion1 + proportion2 + proportion3;
  const normalizedProportion1 = proportion1 / totalProportion;
  const normalizedProportion2 = proportion2 / totalProportion;
  const movementAmplitude = 0.03;
  const movementSpeed = 0.15;
  gl.uniform1f(uniforms.uProportion1, normalizedProportion1);
  gl.uniform1f(uniforms.uProportion2, normalizedProportion2);
  gl.uniform1f(uniforms.uMovementAmplitude, movementAmplitude);
  gl.uniform1f(uniforms.uMovementSpeed, movementSpeed);
}

/*
function updateShaderPanel() {
  const color1 = document.getElementById("color1").value;
  const color2 = document.getElementById("color2").value;
  const color3 = document.getElementById("color3").value;
  const proportion1 = parseInt(document.getElementById("proportion1").value);
  const proportion2 = parseInt(document.getElementById("proportion2").value);
  const proportion3 = parseInt(document.getElementById("proportion3").value);
  const totalProportion = proportion1 + proportion2 + proportion3;
  const normalizedProportion1 = proportion1 / totalProportion;
  const normalizedProportion2 = proportion2 / totalProportion;
  const movementAmplitude = parseFloat(
    document.getElementById("movementAmplitude").value,
  );
  const movementSpeed = parseFloat(
    document.getElementById("movementSpeed").value,
  );

  gl.uniform1f(uniforms.uProportion1, normalizedProportion1);
  gl.uniform1f(uniforms.uProportion2, normalizedProportion2);
  gl.uniform1f(uniforms.uMovementAmplitude, movementAmplitude);
  gl.uniform1f(uniforms.uMovementSpeed, movementSpeed);
  gl.uniform3fv(uniforms.uColor1, hexToRGB(color1));
  gl.uniform3fv(uniforms.uColor2, hexToRGB(color2));
  gl.uniform3fv(uniforms.uColor3, hexToRGB(color3));
}
*/

const COLORS = [
  [hexToRGB("#c7c7c7"), hexToRGB("#1021E8"), hexToRGB("#181818")],
  [hexToRGB("#c7c7c7"), hexToRGB("#c7c7c7"), hexToRGB("#1021E8")],
  [hexToRGB("#c7c7c7"), hexToRGB("#c7c7c7"), hexToRGB("#c7c7c7")],
  [hexToRGB("#1021E8"), hexToRGB("#1021E8"), hexToRGB("#c7c7c7")],
  [hexToRGB("#1021E8"), hexToRGB("#1021E8"), hexToRGB("#1021E8")],
  [hexToRGB("#181818"), hexToRGB("#181818"), hexToRGB("#1021E8")],
  [hexToRGB("#181818"), hexToRGB("#181818"), hexToRGB("#181818")],
  // [hexToRGB("#ffaa33"), hexToRGB("#f46325"), hexToRGB("#fa0505")],
];

function colorsAtIndex(i) {
  return COLORS[i % COLORS.length];
}

function updateShaderColor(time) {
  const index = Math.floor(time);

  const [c11, c12, c13] = colorsAtIndex(index);
  const [c21, c22, c23] = colorsAtIndex(index + 1);

  const progress = time - index;

  const color1 = mixColor(c11, c21, 1 - progress);
  const color2 = mixColor(c12, c22, 1 - progress);
  const color3 = mixColor(c13, c23, 1 - progress);

  gl.uniform3fv(uniforms.uColor1, color1);
  gl.uniform3fv(uniforms.uColor2, color2);
  gl.uniform3fv(uniforms.uColor3, color3);
}

function animate(time) {
  requestAnimationFrame(animate);
  updateShaderColor(time * 0.00008);
  gl.uniform1f(uniforms.uTime, time * 0.001);
  gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
}

function resizeCanvas() {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  gl.viewport(0, 0, canvas.width, canvas.height);
  gl.uniform2f(uniforms.uResolution, canvas.width, canvas.height);
}

function mixColor(color1, color2, proportion) {
  return color1.map((c, i) => c * proportion + color2[i] * (1 - proportion));
}

window.addEventListener("resize", resizeCanvas);

// [
//   "color1",
//   "color2",
//   "color3",
//   "proportion1",
//   "proportion2",
//   "proportion3",
//   "movementAmplitude",
//   "movementSpeed",
// ].forEach(id => {
//   document.getElementById(id).addEventListener("input", updateShaderPanel);
// });

gl.useProgram(program);
resizeCanvas();
initUniforms();
// updateShaderPanel();
animate(0);
